module.exports = __webpack_public_path__ + "static/img/uwr.fb6f086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uwr.png
// module id = kcpG
// module chunks = 0